/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import React, { useState } from 'react';
import { GET_NOTIFICATIONS, MARK_AS_READ_NOTIFICATION } from 'api';
import { HeaderNavbar } from '../../modules/tt-navmenu';
// import 'tt-navmenu/dist/index.css';
import { SignInUpModalWrapper } from '../Modals/SignInUpModal/SignInUpModal';
import { useSelectedContext } from 'context/contextSelector';
import CompanySelectorWrapper from '../CompanySelectorWrapper';

const Navbar = (props) => {
  const {
    avaProps,
    logOut,
    setOpenSupportChat,
    marketTTUrl,
    setNotifications,
    notifications,
    notificationEventTarget,
    setNotificationEventTarget,
  } = props;

  const { user } = useSelectedContext((context) => context.user);

  const [showNeedKYCModal, setShowNeedKYCModal] = useState(false);
  const [isAgreementModalOpen, setIsAgreementModalOpen] = useState(false);
  const [anchorLoginEl, setAnchorLoginEl] = useState(null);
  const open = Boolean(anchorLoginEl);

  const handleLoginClose = () => {
    setAnchorLoginEl(null);
  };

  return (
    <>
      <HeaderNavbar
        avaProps={avaProps}
        getNotificationsQuery={GET_NOTIFICATIONS}
        markAsReadNotificationsMutation={MARK_AS_READ_NOTIFICATION}
        anchorLoginEl={anchorLoginEl}
        setAnchorLoginEl={setAnchorLoginEl}
        user={user}
        notificationSocket={process.env.REACT_APP_WS}
        setShowNeedKYCModal={setShowNeedKYCModal}
        setIsAgreementModalOpen={setIsAgreementModalOpen}
        marketTTUrl={marketTTUrl}
        logOut={logOut} // TODO check if need
        mode="main"
        setNotifications={setNotifications}
        notifications={notifications}
        notificationEventTarget={notificationEventTarget}
        setNotificationEventTarget={setNotificationEventTarget}
      />

      {user && (
        <div style={{ position: 'fixed', top: '70px', right: '20px', zIndex: 1000 }}>
          <CompanySelectorWrapper />
        </div>
      )}

      <SignInUpModalWrapper
        anchorEl={anchorLoginEl}
        open={open}
        closeModal={handleLoginClose}
        setOpenSupportChat={setOpenSupportChat}
      />
    </>
  );
};

export default Navbar;
